const SESSION_TOKEN_KEY = "reflecta.sessionToken";

export const getSessionToken = () => {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(SESSION_TOKEN_KEY);
};

export const setSessionToken = (token) => {
  if (typeof window === "undefined") return;
  if (token) {
    window.localStorage.setItem(SESSION_TOKEN_KEY, token);
  } else {
    window.localStorage.removeItem(SESSION_TOKEN_KEY);
  }
};

export const clearSessionToken = () => setSessionToken(null);
